import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const MagicRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Parse from hash, e.g. "#/magic?access=...&refresh=..."
    const hash = window.location.hash;
    const queryIndex = hash.indexOf('?');
    const queryString = queryIndex !== -1 ? hash.substring(queryIndex + 1) : '';
    const params = new URLSearchParams(queryString);

    const access = params.get('access');
    const refresh = params.get('refresh');

    if (access && refresh) {
      // Store tokens
      localStorage.setItem('authToken', access);
      localStorage.setItem('refreshToken', refresh);

      // Navigate to the dashboard
      navigate('/app/dashboard');
    } else {
      console.error('No access or refresh token in URL.');
      navigate('/app/login');
    }
  }, [navigate]);

  return <div>Logging you in...</div>;
};

export default MagicRedirect;

